import Avatar from '@ui/Avatar';
import Button from '@ui/Button';
import Typography from '@ui/Typography';
import { cx } from 'cva';
import React from 'react';
import { FaUser } from 'react-icons/fa';
import useStore from '@/stores/store';
import { CampaignType } from '@/constants/postType.constants';
import useHasUserSession from '@/hooks/useHasUserSession';
import useJoinNonProfitDialogStore from '../store/joinNonProfitDialogSlice';
import useConnectModalStore from '../store/connectModalSlice';
import OrgType from '@/constants/orgType.constant';
import { useRouter } from 'next/navigation';
import useNonProfitSignUpPopUpStore from '../store/nonProfitSignUpPopUpSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';

function LatestInKindDonors(props) {
  const { post } = props;
  const latestDonors = post.latestInKindDonors || [];

  const hasUserSession = useHasUserSession();
  const router = useRouter();

  const showPostContributorDialog = useStore(
    (state) => state.postContributorDialog.showDialog,
  );

  const setShowJoinNonProfitModal = useJoinNonProfitDialogStore(
    (state) => state.setOpen,
  );
  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);

  const setShowNonProfitSignUpPopUp = useNonProfitSignUpPopUpStore(
    (state) => state.setOpen,
  );
  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  const handleShowAllContributors = () => {
    if (hasUserSession) {
      if (post) {
        showPostContributorDialog(
          post,
          CampaignType.CollectGoods,
          'contributors',
        );
      }
    } else {
      if (
        [OrgType.Business, OrgType.ChangeMakers].includes(
          post.renderProps.company.orgType,
        )
      ) {
        // setShowConnectModal(true, post.renderProps.company);
        setShowCompanyConnectPopUp(true, post.renderProps.company);
      } else {
        // setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      }
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center -space-x-4">
        {latestDonors.length > 0 &&
          latestDonors.map((donor, index) => (
            <div
              key={index}
              className={cx(
                'relative inline',
                `z-${(latestDonors.length - index) * 10}`,
              )}>
              <Avatar
                profile="user"
                src={donor.avatar}
                alt={`${donor.firstName} ${donor.lastName}`}
              />
            </div>
          ))}
      </div>
      {post.totalInKindDonors > 0 && (
        <Typography
          // variant="body1"
          // variant="caption"
          variant="hyperlink"
          // color="textSecondary"
          // className="hover:text-text-hyperlink"
          className="hover:cursor-pointer"
          onClick={handleShowAllContributors}>
          {`${post.totalInKindDonors} ${
            post.totalInKindDonors > 1 ? ' people' : ' person'
          } donated`}
        </Typography>
      )}
    </div>
  );
}

export default LatestInKindDonors;
